<template>
  <div class="row platformDeclaration">
    <div class="col">
      <div class="Title">平台聲明</div>
      <div class="Declaration" v-html="this.$parent.$data.platformDeclaration"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlatformDeclaration",
}
</script>

<style lang="scss" scoped>
.platformDeclaration {
  margin: 20px auto 20px auto !important;
  > .col {
    > .Title {
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: 900;
      color: #87CEFAAA;
      text-shadow: 1px 1px 0 #000000;
    }
    > .Declaration {
      padding: 15px 20px 15px 20px;
      border-radius: 8px;
      background: #f8f8f8;
      color: #000000;
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>